import { render } from "./AssistantChat.vue?vue&type=template&id=1798c951&scoped=true"
import script from "./AssistantChat.vue?vue&type=script&lang=js"
export * from "./AssistantChat.vue?vue&type=script&lang=js"

import "./AssistantChat.vue?vue&type=style&index=0&id=1798c951&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1798c951"]])

export default __exports__